function fixSwatchWrap() {
    document.querySelectorAll(".swatch-container").forEach(el => {
        el.style.setProperty("flex-wrap", "wrap", "important");
        el.style.setProperty("overflow-x", "visible", "important");
    });

    document.querySelectorAll(".swatch-container .swatch label").forEach(el => {
        el.style.setProperty("width", "60px", "important");
        el.style.setProperty("min-width", "60px", "important");
        el.style.setProperty("max-width", "60px", "important");
        el.style.setProperty("height", "60px", "important");
        el.style.setProperty("min-height", "60px", "important");
        el.style.setProperty("max-height", "60px", "important");
    });

    document.querySelectorAll(".swatch-container .swatch img").forEach(el => {
        el.style.setProperty("width", "54px", "important");
        el.style.setProperty("min-width", "54px", "important");
        el.style.setProperty("max-width", "54px", "important");
        el.style.setProperty("height", "54px", "important");
        el.style.setProperty("min-height", "54px", "important");
        el.style.setProperty("max-height", "54px", "important");
    });
}

function replaceOcuThumbnails() {
    document.querySelectorAll('.ocu-cart-line-item-wrapper').forEach(item => {
        try {
            const props = JSON.parse(item.getAttribute('data-properties') || '{}');
            const thumb = props['_customily-thumb'];
            if (!thumb) return;

            const img = item.querySelector('.ocu-cart-line-item-image img');
            if (img && img.src !== thumb) {
                img.src = thumb;
                img.style.width = "auto";
                img.style.height = "150px";
            }
        } catch (e) {}
    });
}

const observer = new MutationObserver(() => {
    fixSwatchWrap();
    replaceOcuThumbnails();
});

observer.observe(document.body, { childList: true, subtree: true });